const SORTING_TYPES = Object.freeze({
  NO_SORTING: "noSorting",
  ASC: "asc",
  DESC: "desc"
});
export {
  SORTING_TYPES
};
